import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Loader from "src/components/loader/loader";
const LoaderWrapper = (comp) => {
    return (_jsx(React.Suspense, Object.assign({ fallback: _jsx("div", Object.assign({ className: "full-height" }, { children: _jsx(Loader, {}) })) }, { children: comp })));
};
export default LoaderWrapper;
